import React from "react";
import { connect } from "react-redux";
import ShipCard from "./ShipCard";
import {
  getClientShipCount,
  getClientShipSearch,
} from "../Actions/ClientDashboardAPI";
import "react-datepicker/dist/react-datepicker.css";
import { AutoComplete } from "primereact/autocomplete";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import CountUp from "react-countup";
import axios from "axios";
import API from "../helpers/api";
import { Paginator } from "primereact/paginator";

const searchItem = {
  shipName: "",
  pageSize: 25,
};

class ConsultantDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allShipo: 100,
      expiredShips: 100,
      expiringShips: 90,
      filterTitle: "All Ships",
      SelectedFromDate: "",
      SelectedToDate: "",
      totalCount: 0,
      searchShips: {
        shipName: "",
        clientName: "",
        pageSize: 10,
        pageNumber: 1,
      },
      clientCount: 0,
      clientlist: [
        // {
        //   clientId: 72,
        //   clientName: "Qantlertesting",
        //   shipNames: ["testship", "lrfrom test data", "LRFrom Test Ship"],
        // },
        // {
        //   clientId: 54,
        //   clientName: "Synergy Ocean Maritime Inc",
        //   shipNames: ["EHIME QUEEN", "GOOD HORIZON", "MIA LR"],
        // },
        // {
        //   clientId: 71,
        //   clientName: "Maryam Shipping S.A",
        //   shipNames: ["MESHKA"],
        // },
      ],
      shipsearch: false,
      EquipmentList: ["A_Equipment1", "B_Equipment2", "C_Equipment"],
    };

    this.SearchShipsData = this.SearchShipsData.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, ShipClientSuccess } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    dispatch(getClientShipCount());
    this.getClientList(this.state.searchShips);
    this.getClientListCount();
    // if (ShipClientSuccess) {
    //   dispatch(getClientShipSearch(ShipClientSuccess, 1));
    // } else {
    //   dispatch(getClientShipSearch(this.state.searchShips, 1));
    // }
  }

  getClientList = (item) => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let url = `${API.ConsultantCLients}?Mail=${user.email}&CompanyName=${
      item.clientName ?? ""
    }&shipName=${item.shipName ?? ""}&pageSize=${item.pageSize}&pageNumber=${
      item.pageNumber
    }`;
    axios
      .get(url)
      .then((response) => {
        this.setState({
          clientlist: response.data.clients.items,
          totalCount: response.data.clients.totalCount,
        });
      })
      .catch((error) => {});
  };

  getClientListCount = () => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let url = `${API.ConsultantCLients}/count?email=${user.email}`;
    axios
      .get(url)
      .then((response) => {
        this.setState({ clientCount: response.data.clientCount });
      })
      .catch((error) => {});
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, ShipClientSuccess } = nextProps;
    // if (
    //   ShipClientSuccess &&
    //   !prevState.shipsearch &&
    //   ShipClientSuccess !== ""
    // ) {
    //   prevState.searchShips.shipName = ShipClientSuccess.shipName;
    //   prevState.shipsearch = true;
    // }
  }

  SearchShipsData(pageNo) {
    const { dispatch } = this.props;
    this.state.shipsearch = false;
    this.setState(
      (prevState) => ({
        searchShips: {
          ...prevState.searchShips,
          pageNumber: pageNo,
        },
      }),
      () => {
        this.getClientList(this.state.searchShips);
      }
    );

    // dispatch(getClientShipSearch(this.state.searchShips, pageNo));
  }

  ClearSearchField() {
    const { dispatch } = this.props;
    this.state.shipsearch = false;
    this.props.dispatch({ type: "shipClientSuccess", data: "" });
    let param = { ...searchItem };
    this.setState(
      {
        searchShips: {
          shipName: "",
          clientName: "",
          pageSize: 10,
          pageNumber: 1,
        },
      },
      () => {
        this.getClientList(this.state.searchShips);
      }
    );
  }

  handleInputChange(e, field) {
    this.state.searchShips[field] = e.target.value;
    this.setState({
      searchShips: this.state.searchShips,
    });
  }

  suggestMItable(event) {
    let results = this.state.EquipmentList.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });
    this.setState({ EquipmentList: results });
  }

  onPaginatorChange(event) {
    // this.setState({ currentPage: event.first });
    // setUpdatedState(event.page + 1);
    this.setState(
      (prevState) => ({
        searchShips: {
          ...prevState.searchShips,
          pageNumber: event.page + 1,
        },
      }),
      () => {
        this.getClientList(this.state.searchShips);
      }
    );
  }

   ShipDashboardNavigation = (id) => {
    this.props.dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    this.props.history.push(`/Home/SpecialAccess/ships/${id}`);
  };

  render() {
    const { showSidePane, clientShipSearch, clientShipCount } = this.props;

    return (
      <div className="full-height pt-3 pb-3">
        <div className="row">
          <div className="col-lg-12">
            <div
              className="card card-selector text-center mb-0"
              style={{ cursor: "auto" }}
            >
              <h1>
                {" "}
                <CountUp
                  start={0}
                  end={this.state.clientCount ? this.state.clientCount : 0}
                  duration={1.5}
                  separator=","
                />
              </h1>
              <h5>Total Clients</h5>
            </div>
          </div>
        </div>
        <div className="row my-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header m-auto"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    All Clients
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row" style={{ paddingBottom: "12px" }}>
                  <div className="col-lg-4">
                    <label className="form-label">Client Name</label>
                    <br></br>
                    <AutoComplete
                      value={this.state.searchShips.clientName}
                      onChange={(e) => this.handleInputChange(e, "clientName")}
                      suggestions={this.state.EquipmentList}
                      completeMethod={this.suggestMItable.bind(this)}
                      name="tableValue"
                      inputClassName="form-control"
                      style={{ display: "block" }}
                      inputStyle={{ borderColor: "#ced4da", height: "38px" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">Ship Name</label>
                    <br></br>
                    <AutoComplete
                      value={this.state.searchShips.shipName}
                      onChange={(e) => this.handleInputChange(e, "shipName")}
                      suggestions={this.state.EquipmentList}
                      completeMethod={this.suggestMItable.bind(this)}
                      name="tableValue"
                      inputClassName="form-control"
                      style={{ display: "block" }}
                      inputStyle={{ borderColor: "#ced4da", height: "38px" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label"></label>
                    <br></br>
                    <div
                      className="mt-3 search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.SearchShipsData(1)}
                      >
                        Search
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.ClearSearchField()}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.clientlist && this.state.clientlist.length > 0 ? (
          <div className=" mt-0 mb-4 ml-0 mr-0 cardBck1 row">
            <div className="col-xl-12 py-3">
              <div className="row px-3">
                {this.state.clientlist.map((item, index) => {
                  return (
                    <>
                      <div
                        className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 p-2 cursor-pointer"
                        onClick={(e) =>
                          this.ShipDashboardNavigation(item.clientId)
                        }
                      >
                        <div className="card ccard px-4 pt-3 h-100 d-flex flex-column">
                          <div className="bold-count">
                            {item.shipNames.length}
                          </div>
                          <div className="bord-title pt-1">
                            {item.clientName}
                          </div>

                          <div
                            className="mt-3 mb-2"
                            style={{ border: "0.1px solid #EEEEEE" }}
                          ></div>
                          <div className="row mt-auto mb-2">
                            <div className="sub-card col-12 d-flex align-items-center justify-content-between">
                              <span style={{ fontSize: "16px" }}>Ships</span>
                              <i class=" fa fa-arrow-right fa-2x fa-lg click py-2 px-0 "></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        ) : this.state.clientlist.length == 0 ? (
          <div className="mt-0 mb-4 ml-0 mr-0  cardBck1 row">
            <div className="col-xl-12">
              <h6 className="bold-count no-item-card f-size">No Clients</h6>
            </div>
          </div>
        ) : null}
        {this.state.clientlist.length !== 0 && (
          <Paginator
            first={(this.state.searchShips.pageNumber - 1) * this.state.searchShips.pageSize}
            rows={this.state.searchShips.pageSize}
            totalRecords={this.state.totalCount}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        )}
        {/* {clientShipSearch ? (
          <ShipCard
            arraylist={clientShipSearch.data}
            pageSize={clientShipSearch.pagination.pageSize}
            currentPage={clientShipSearch.pagination.currentPage}
            totalRecords={
              clientShipSearch.pagination.totalcount
                ? clientShipSearch.pagination.totalcount
                : 0
            }
            setUpdatedState={(value) => this.SearchShipsData(value)}
          />
        ) : null} */}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    clientShipCount: state.ClientDashboardReducer.ClientShipCount,
    clientShipSearch: state.ClientDashboardReducer.ClientShipSearch,
    ShipClientSuccess: state.ClientDashboardReducer.ShipClientSuccess,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsultantDashboard);
